<template>
  <div id="app">
    <div class="page-container">
      <div class="dashboard-header">
        <div class="header-content">
          <router-link to="/dashboard" class="nav-btn">
            <span class="nav-icon">←</span>
            <span>Dashboard</span>
          </router-link>
          <h1>Geopolitik</h1>
          <div class="user-section">
            <div class="notifications">
              <span class="notification-icon">🔔</span>
            </div>
            <div class="user-profile">
              <img :src="userPhotoUrl" alt="User" class="user-avatar" />
            </div>
          </div>
        </div>
      </div>

      <div class="content-grid" v-if="showFeatured">
        <div
          class="news-card featured high-priority"
          v-for="(news, index) in staticNews"
          :key="index">
          <div class="news-tag">{{ news.tag }}</div>
          <h2>{{ news.title }}</h2>
          <p class="news-meta">{{ news.meta }}</p>
          <p class="news-excerpt">{{ news.excerpt }}</p>
          <button class="read-more" @click="openLink(news.url)">Zum Artikel</button>
        </div>
      </div>

      <div id="categories-container">
        <div
          class="subcategory-section"
          v-for="(category, index) in categoriesData"
          :key="index"
        >
         <h2 class="section-title" @click="navigateToCategory(category.name)" style="cursor: pointer;">
            {{ category.name }}
          </h2>
          <div class="articles-container">
            <div class="articles-masonry">
              <div
                v-for="article in getVisibleArticles(category)"
                :key="article.id"
                class="article-card"
                :class="{ 'with-image': article.image_url }"
              >
                <img
                  v-if="article.image_url"
                  :src="article.image_url"
                  :alt="article.title"
                  class="article-image"
                  @click="openLink(article.url)"
                />
                <div class="article-content">
                  <div class="article-meta">
                    <span class="article-date">{{ formatDate(article.published_at) }}</span>
                    <span v-if="article.publisher_name" class="article-publisher">
                      {{ article.publisher_name }}
                    </span>
                  </div>
                  <h3 class="article-title" @click="openLink(article.url)">
                    {{ article.title }}
                  </h3>
                  <div class="tags-row">
                    <template v-if="article.tags && article.tags.trim() !== ''">
                      <span
                        v-for="(tag, tagIndex) in article.tags.split(',')"
                        :key="tagIndex"
                        class="tag-pill"
                        @click="navigateToTag(tag.trim())"
                      >
                        {{ tag.trim() }}
                      </span>
                    </template>
                    <template v-else>
                      <span class="tag-pill">News</span>
                    </template>

                  </div>
               
                  <p class="article-excerpt" :style="article.expanded ? 'display: block; -webkit-line-clamp: unset;' : ''">
  {{ article.expanded ? article.content : getExcerpt(article.content) }}
</p>

                  <div class="article-actions">
                    <button 
                      class="action-btn expand"
                      v-if="article.content && article.content.length > 200"
                      @click="toggleExpand(article)"
                    >
                      {{ article.expanded ? '−' : '+' }}
                    </button>
                    <button class="action-btn read" @click="openLink(article.url)">
                      Lesen →
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-controls" v-if="category.articles.length > 4">
              <button
                class="carousel-btn prev"
                @click="prevArticles(category)"
              >
                &#9664;
              </button>
              <button
                class="carousel-btn next"
                @click="nextArticles(category)"
              >
                &#9654;
              </button>
            </div>
          </div>
          <p v-if="category.articles.length === 0">Keine Artikel gefunden.</p>
        </div>
      </div>

      <button
        v-if="showScrollButton"
        class="scroll-top-button"
        @click="scrollToTop"
      >
        ↑
      </button>
    </div>
  </div>
</template>

<script>
export default {
name: 'GeopoliticsView',
data() {
  return {
    userPhotoUrl: 'https://via.placeholder.com/40',
    staticNews: [
      {
        tag: 'Breaking',
        title: 'Rising Cyber Tensions Between Major Powers',
        meta: 'Updated 2 hours ago • High Priority',
        excerpt:
          'Analysis of increasing cyber operations and their impact on global security landscape...',
        url: '#'
      },
      {
        tag: 'Analysis',
        title: 'State-Sponsored Activities in Eastern Europe',
        meta: '1 day ago • Medium Priority',
        excerpt:
          'Detailed report on recent cyber operations targeting critical infrastructure...',
        url: '#'
      },
      {
        tag: 'Report',
        title: 'Maritime Sector Cyber Threats',
        meta: '2 days ago • Medium Priority',
        excerpt: 'Analysis of cyber threats affecting global maritime operations...',
        url: '#'
      }
    ],
    categoriesData: [
      { name: 'Europe', articles: [], currentIndex: 0 },
      { name: 'USA', articles: [], currentIndex: 0 },
      { name: 'China', articles: [], currentIndex: 0 },
      { name: 'Russia', articles: [], currentIndex: 0 },
      { name: 'Switzerland', articles: [], currentIndex: 0 },
      { name: 'APAC', articles: [], currentIndex: 0 },
      { name: 'Middle East', articles: [], currentIndex: 0 },
      { name: 'Latin America', articles: [], currentIndex: 0 },
      { name: 'Africa', articles: [], currentIndex: 0 }
    ],
    showScrollButton: false,
    showFeatured: false
  };
},
methods: {
  formatDate(dateString) {
    const date = new Date(dateString);
    const options = { hour: '2-digit', minute: '2-digit' };
    return (
      date.toLocaleDateString('de-DE') +
      ' ' +
      date.toLocaleTimeString('de-DE', options)
    );
  },
  getExcerpt(content) {
  if (!content) return '';
  const lines = content.split('\n').slice(0, 3);
  let summary = lines.join('\n');
  if (content.length > summary.length) summary += '...';
  return summary;
},
  displaySummary(article) {
    return article.expanded ? article.content : this.getExcerpt(article.content);
  },
  toggleExpand(article) {
    article.expanded = !article.expanded;
  },
  openLink(url) {
    const smryUrl = `https://smry.ai/${url}`;
    window.open(smryUrl, '_blank');
  },
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  logout() {
    alert('Logout clicked');
  },
  nextArticles(category) {
    const totalSets = Math.ceil(category.articles.length / 4);
    const currentSet = Math.floor(category.currentIndex / 4);
    category.currentIndex = ((currentSet + 1) % totalSets) * 4;
  },

  prevArticles(category) {
    const totalSets = Math.ceil(category.articles.length / 4);
    const currentSet = Math.floor(category.currentIndex / 4);
    category.currentIndex = ((currentSet - 1 + totalSets) % totalSets) * 4;
  },

  getVisibleArticles(category) {
    const start = category.currentIndex;
    let end = start + 4;
    
    if (end > category.articles.length) {
      end = category.articles.length;
    }
    
    return category.articles.slice(start, end);
  },

  navigateToTag(tag) {
    this.$router.push({
      path: '/tags',
      query: { tag: tag }
    });
  },

  navigateToCategory(category) {
    this.$router.push({
      path: '/category',
      query: { name: category }
    });
  },

  fetchArticles(category) {
    fetch(
      `https://api.trj.dev/articles?subcategory=${encodeURIComponent(
        category.name
      )}&limit=20`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.articles && data.articles.length > 0) {
          category.articles = data.articles.map((article) => {
            article.expanded = false;
            return article;
          });
          category.currentIndex = 0;
        } else {
          category.articles = [];
        }
      })
      .catch((error) => {
        console.error(
          'Fehler beim Laden der Artikel für Subcategory ' + category.name,
          error
        );
        category.articles = [];
      });
  },

  handleScroll() {
    this.showScrollButton = window.pageYOffset > 300;
  }
},

mounted() {
  window.scrollTo(0, 0);
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'auto';
  }
  this.categoriesData.forEach((category) => {
    this.fetchArticles(category);
  });
  window.addEventListener('scroll', this.handleScroll);
},

created() {
  this.$router.beforeEach((to, from, next) => {
    if (to.path === '/geopolitics') {
      // Reset component state
      this.categoriesData.forEach(category => {
        category.currentIndex = 0;
        this.fetchArticles(category);
      });
    }
    next();
  });
},

beforeUnmount() {
  window.removeEventListener('scroll', this.handleScroll);
}
};
</script>

<style>
/* Basis-Styles */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  font-family: 'Poppins', sans-serif;
  background: #1a1a2e;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  margin: 0;
  padding: 1rem 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  align-items: center;
}

#categories-container {
  flex: 1;
  width: 90%;
  max-width: 1800px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
}

.dashboard-header {
  width: 100%;
  padding: 0;
  margin-bottom: 3rem;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.subcategory-section {
  width: 100%;
  padding: 0.25rem 1rem;
  margin-bottom: 0.15rem;
  position: relative;
}

.section-title {
  color: #ffffff;
  font-size: 1.8rem;
  margin: 0.5rem 0;
  padding-left: 1rem;
}

.article-card {
  background: rgba(20, 20, 28, 0.95);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.article-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

.article-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  padding: 1.5rem;
  padding-bottom: 80px;
}

.article-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.articles-container {
  position: relative;
  width: 100%;
  padding: 0 2rem;  /* Reduziert von 3rem */
}

.article-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 0.75rem;
}

.article-title {
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 1rem;
  line-height: 1.4;
  cursor: pointer;
}

.articles-masonry {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 1.5rem;
  padding: 1rem 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.article-excerpt {
  flex: 1;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.3s ease;
}

.article-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.5rem;
  background: rgba(20, 20, 28, 0.95);
  transition: all 0.3s ease;
}

.article-card:hover .article-actions {
  background: rgba(255, 255, 255, 0.05);
}

.action-btn {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.action-btn.expand {
  width: 36px;
  padding: 0;
}

.action-btn.read {
  padding: 0 1.5rem;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Karussell */
.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  z-index: 10;
  width: 100%;
}

.carousel-btn {
  pointer-events: auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.carousel-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-50%) scale(1.1);
}

.carousel-btn.prev {
  left: -20px;
}

.carousel-btn.next {
  right: -20px;
}

/* Scroll-Button */
.scroll-top-button {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.5rem;
}

.scroll-top-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tag-pill {
  padding: 0.4rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tag-pill:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.top-nav {
  margin-bottom: 3rem;
  width: 100%;
  max-width: 1800px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
}

.header-content {
  max-width: 80%;
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.header-content h1 {
  font-size: 2.5rem;
  font-weight: 600;
  background: linear-gradient(135deg, #fff 0%, #a8b2d1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.notifications {
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.2s ease;
}

.notifications:hover {
  opacity: 1;
}

.user-profile {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.2s ease;
}

.user-profile:hover {
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.user-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .articles-masonry {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 768px) {
  .articles-masonry {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
}

@media (max-width: 480px) {
  .articles-masonry {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .header-content {
    padding: 1rem 1.5rem;
  }
}
</style>